import auth from "../../../app-auth-container";
import alias from "../../../app-alias-container";

const Modules = {
  auth,
  alias,
};

export default Modules;
